import * as React from 'react';

import FolderFloat140 from './FolderFloat140';

export const folderFloat140 = () => <FolderFloat140 />;

export default {
    title: 'Illustration|FolderFloat140',
    component: FolderFloat140,
    parameters: {
        notes: "`import FolderFloat140 from 'box-ui-elements/es/illustration/FolderFloat140';`",
    },
};
